import * as TypesPoints from '../types/types_points';
import Vue from 'vue';
import _ from 'lodash';

function classifyArr(tarr, params) {
    let classifyArr = {};
    let finallyArr = [];
    let categoryList = [];
    tarr.forEach(item => {
        item[params] = item[params] === '' ? '未关联考法' : item[params];
        if (!classifyArr[item[params]]) {
            const arr = [];
            arr.push(item);
            classifyArr[item[params]] = arr;
        } else {
            classifyArr[item[params]].push(item);
        }
    });
    _.forEach(classifyArr, (item, key) => {
        categoryList.push(key);
        finallyArr.push({
            name: key,
            value: item,
            isExpend: false,
            categoryList: categoryList
        });
    });
    if (finallyArr && finallyArr.length) {
        finallyArr[0].isExpend = true;
    }
    return finallyArr;
}
export default {
    state: {
    // 备课或讲义修改会同步到这里
        sessionName: '',
        // 标记备课是否修改过
        pointEdited: false,
        knowledgePoint: {},
        pointList: [],
        currentPoint: {},
        basket: {}
    },
    mutations: {
        [TypesPoints.POINTS_SET_ITEMS](state, payload) {
            // console.log(state, payload);
            // payload -> name, knowledgePoints
            if (payload) {
                let knowledgePoint = {};
                let pointList = [];
                let points = payload || {};
                // console.log(points)
                if (points) {
                    let difficulty = points.difficulty || 'normal'; // 困难度
                    let kid = points.knowledgePointId;
                    pointList.push({
                        id: kid,
                        name: points.name, // 课件名
                        difficulty // 课件难度
                    });
                    if (points.practiceLessonQuestions && points.practiceLessonQuestions.length) {
                        points.newpracticeLessonQuestions = classifyArr(points.practiceLessonQuestions, 'category');
                    } else {
                        points.newpracticeLessonQuestions = [];
                    }
                    if (points.withinLessonQuestions && points.withinLessonQuestions.length) {
                        points.newwithinLessonQuestions = classifyArr(points.withinLessonQuestions, 'category');
                    } else {
                        points.newwithinLessonQuestions = [];
                    }
                    if (knowledgePoint[kid]) {
                        if (!knowledgePoint[kid][difficulty]) {
                            knowledgePoint[kid][difficulty] = points;
                        }
                    } else {
                        knowledgePoint[kid] = {};
                        knowledgePoint[kid][difficulty] = points;
                    }
                    state.currentPoint = {
                        id: points.knowledgePointId,
                        name: points.name,
                        difficulty: points.difficulty
                    };
                    // console.log(state.currentPoint)
                } else {
                    state.currentPoint = {};
                }
                if (payload.name) {
                    state.sessionName = payload.name;
                }
                state.knowledgePoint = knowledgePoint;
                state.pointList = pointList;
                state.pointEdited = false;
                // console.log('=====', state.knowledgePoint, state.pointList, state.pointEdited)
            } else {
                state.sessionName = '';
                state.knowledgePoint = {};
                state.pointList = [];
                state.currentPoint = {};
                state.pointEdited = false;
            }
            // 清空试题篮
            state.basket = {};
            // console.log(state.basket[payload.id])
        },
        // 更新讲义 包含知识点更新及 难度更新
        [TypesPoints.POINTS_CHANGE_COURSEWARE](state, payload) {
            // console.log('payload', state, payload);
            // payload 参数： id: 知识点Id  difficulty
            let point = state.knowledgePoint[payload.knowledgePointId][payload.difficulty];
            // 检测当前 知识点是否有 hasAdd 标识, 没有就需将试题篮中题目赋值
            let currentBasketPoint = state.basket[payload.knowledgePointId];
            if (!point.hasAdd && currentBasketPoint) {
                // 当知识点切换难度  需追加 相应试题篮中的已选数据
                let stageKeys = Object.keys(currentBasketPoint);
                let stageKeysLen = stageKeys.length;
                if (stageKeysLen) {
                    for (let i = 0; i < stageKeysLen; i++) {
                        point[stageKeys[i]] = currentBasketPoint[stageKeys[i]].concat(point[stageKeys[i]]);
                    }
                    point.hasAdd = true;
                }
            }
            state.currentPoint = {
                id: point.knowledgePointId,
                name: point.name,
                difficulty: point.difficulty
            };
            // console.log('99', state.currentPoint);
        },
        // 编辑课节，移除部分知识点 mutations
        [TypesPoints.POINTS_REMVOE_ITEMS](state, payload) {
            // payload 参数 name(课程标题), pointList（编辑过的知识点列表）,
            // removePoints array ：[id: 知识点Id  name, difficulty]
            let knowledgePoint = _.cloneDeep(state.knowledgePoint);
            let currentPointId = state.currentPoint.knowledgePointId;
            let hasCurrentPoint = false;
            payload.removePoints.forEach(item => {
                if (!hasCurrentPoint && item.id === currentPointId) {
                    hasCurrentPoint = true;
                }
                delete knowledgePoint[item.id];
            });
            if (hasCurrentPoint) {
                let firstPoint = payload.pointList[0];
                // console.log(firstPoint)
                let point = knowledgePoint[firstPoint.id][firstPoint.difficulty];
                state.currentPoint = {
                    id: point.knowledgePointId,
                    name: point.name,
                    difficulty: point.difficulty
                };
            }
            state.pointList = payload.pointList;
            state.knowledgePoint = knowledgePoint;
            state.pointEdited = true;
        },
        [TypesPoints.POINTS_SYNC_SESSION_NAME](state, payload) {
            // payload 参数 name(课程标题)
            state.sessionName = payload || '';
            state.pointEdited = true;
        },
        // 为新增知识点设置推荐习题
        [TypesPoints.POINTS_SET_SESSION](state, payload) {
            // payload 参数 name(课程标题), pointList（编辑过的知识点列表）,
            // removePoints array ：[id: 知识点Id  name, difficulty]
            // coursewareList array 新增讲义
            let knowledgePoint = _.cloneDeep(state.knowledgePoint);
            let currentPointId = state.currentPoint.knowledgePointId;
            let hasCurrentPoint = false;
            payload.removePoints.forEach(item => {
                if (!hasCurrentPoint && item.id === currentPointId) {
                    hasCurrentPoint = true;
                }
                delete knowledgePoint[item.id];
            });
            let points = payload || [];
            // let pointLen = points.length;
            if (points) {
                let difficulty = points.difficulty || 'normal';
                let kid = points.id;
                points.difficulty = difficulty;
                knowledgePoint[kid] = {};
                knowledgePoint[kid][difficulty] = points;
            }
            if (hasCurrentPoint) {
                let firstPoint = payload;
                let point = knowledgePoint[firstPoint.id][firstPoint.difficulty];
                state.currentPoint = {
                    id: point.knowledgePointId,
                    name: point.name,
                    difficulty: point.difficulty
                };
            }
            state.knowledgePoint = knowledgePoint;
            state.pointList = Array.from(payload.pointList);
            // console.log(payload.pointList)
            state.pointEdited = true;
        },
        [TypesPoints.POINTS_SET_DIFFICULTY_POINT](state, payload) {
            let knowledgePoint = _.cloneDeep(state.knowledgePoint);
            // console.log(payload, knowledgePoint);
            let pointList = _.cloneDeep(state.pointList);
            let kid = payload.id;
            let difficulty = payload.difficulty || 'normal';
            payload.difficulty = difficulty;
            if (!knowledgePoint[kid]) {
                knowledgePoint[kid] = {};
            }
            // 当知识点切换难度  需追加 相应试题篮中的已选数据
            let currentBasketPoint = state.basket[kid];
            if (currentBasketPoint) {
                let stageKeys = Object.keys(currentBasketPoint);
                let stageKeysLen = stageKeys.length;
                if (stageKeysLen) {
                    for (let i = 0; i < stageKeysLen; i++) {
                        payload[stageKeys[i]] = currentBasketPoint[stageKeys[i]].concat(payload[stageKeys[i]]);
                    }
                }
            }
            if (payload.practiceLessonQuestions && payload.practiceLessonQuestions.length) {
                payload.newpracticeLessonQuestions = classifyArr(payload.practiceLessonQuestions, 'category');
            } else {
                payload.newpracticeLessonQuestions = [];
            }
            if (payload.withinLessonQuestions && payload.withinLessonQuestions.length) {
                payload.newwithinLessonQuestions = classifyArr(payload.withinLessonQuestions, 'category');
            } else {
                payload.withinLessonQuestions = [];
            }
            knowledgePoint[kid][difficulty] = payload;
            let pointIndex = _.findIndex(pointList, { id: kid });
            // console.log(kid);
            if (pointIndex > -1) {
                pointList[pointIndex] = {
                    id: kid,
                    name: payload.name,
                    difficulty
                };
            }
            state.knowledgePoint = knowledgePoint;
            state.pointList = pointList;
            state.currentPoint = {
                id: kid,
                name: payload.name,
                difficulty
            };
            state.pointEdited = true;
        },
        // 操作问题，移动问题 向上，向下 mutations
        [TypesPoints.POINTS_MOVE_QUESTION](state, payload) {
            // payload 参数 currentIndex  targetIndex  questionStage (问题阶段 0: 课前  1：课堂  2：课后 )
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.questionStage];
            let currentPoint = state.currentPoint;
            let currentClaasifyIndex = payload.currentClaasifyIndex;
            // 交换info knowledgePoint 知识点下的问题位置
            let targetStage = _.cloneDeep(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage][currentClaasifyIndex]); // 所在的组
            if ((payload.targetIndex || payload.targetIndex === 0) && !payload.targetName) {
                let temp = targetStage.value[payload.currentIndex]; // 把现在点击的位置空出来，放进盒子；
                targetStage.value[payload.currentIndex] = targetStage.value[payload.targetIndex];
                targetStage.value[payload.targetIndex] = temp;
            } else {
                // 置顶操作
                let temp = targetStage.value.splice(payload.currentIndex, 1)[0];
                targetStage.unshift(temp);
            }
            Vue.set(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage], currentClaasifyIndex, targetStage);
            state.pointEdited = true;
        },
        // 操作问题，换组问题 mutations
        [TypesPoints.POINTS_TURN_QUESTION](state, payload) {
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.questionStage];
            let currentPoint = state.currentPoint;
            let currentClaasifyIndex = payload.currentClaasifyIndex; // 移动的数据所在的组索引
            let targetStage = _.cloneDeep(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage][currentClaasifyIndex]); // 所在的组
            let targetStagePage = _.cloneDeep(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage]); // 所在的页面===questionStage
            const index = _.findIndex(targetStagePage, item => { // 目标组所在的索引
                return item.name === payload.targetName;
            });
            const currentArr = targetStage.value.splice(payload.currentIndex, 1);
            targetStagePage[index].value.push(currentArr[0]);
            Vue.set(state.knowledgePoint[currentPoint.id][currentPoint.difficulty], currentStage, targetStagePage);
            Vue.set(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage], currentClaasifyIndex, targetStage);
            state.pointEdited = true;
        },
        // 操作问题，删除问题 mutations
        [TypesPoints.POINTS_DELETE_QUESTION](state, payload) {
            // payload 参数 currentIndex  questionStage (问题阶段 0: 课前  1：课堂  2：课后 )
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            const STAGE_ENUM_BASKET = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStageBasket = STAGE_ENUM_BASKET[payload.questionStage];
            let currentStage = STAGE_ENUM[payload.questionStage];

            // console.log(currentStage, currentStageBasket)
            let currentPoint = state.currentPoint;
            // console.log('ww', payload)
            let currentClaasifyIndex = payload.currentClaasifyIndex;
            let oldStageIndex = _.findIndex(state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStageBasket], { id: payload.id });
            state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStageBasket].splice(oldStageIndex, 1);
            // console.log('p', state.knowledgePoint[currentPoint.id][currentPoint.difficulty])
            if (state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage][currentClaasifyIndex]) {
                state.knowledgePoint[currentPoint.id][currentPoint.difficulty][currentStage][currentClaasifyIndex].value.splice(payload.currentIndex, 1);
            }
            if (state.basket[currentPoint.id]) {
                let basketIdx = _.findIndex(state.basket[currentPoint.id][currentStageBasket], { id: payload.id });
                state.basket[currentPoint.id][currentStageBasket].splice(basketIdx, 1);
            }
            state.pointEdited = true;
        },
        // 将所选问题添加到试题篮中 mutations
        [TypesPoints.POINTS_KB_IN_BASKET](state, payload) {
            // console.log('添加', state, payload);
            // payload 参数 pointId (备课知识点ID) difficulty (备课知识点难度) stage 阶段 question 问题整体
            const STAGE_ENUM = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.stage];
            // console.log('currentStage', currentStage);
            let findObj = payload.question.type === 2 ? {
                question: payload.question.question,
                answer: payload.question.answer,
                analysis: payload.question.analysis
            } : { id: payload.question.id };
            // console.log('findObj', findObj);
            // 防重复添加
            if (state.basket[payload.pointId] && state.basket[payload.pointId][currentStage] && _.findIndex(state.basket[payload.pointId][currentStage], findObj) > -1) {
                return false;
            }
            let question = payload.question.type === 2 ? Object.assign({}, payload.question, {
                isNew: true,
                type: 2,
                category: '未关联考法'
            }) : {
                id: payload.question.id,
                isNew: true,
                question: payload.question,
                type: 1,
                category: '未关联考法',
                difficulty: payload.question.difficulty
            };
            if (!state.basket[payload.pointId]) {
                state.basket[payload.pointId] = {};
                state.basket[payload.pointId][currentStage] = [question];
            } else if (!state.basket[payload.pointId][currentStage]) {
                state.basket[payload.pointId][currentStage] = [question];
            } else {
                state.basket[payload.pointId][currentStage].push(question);
            }
            // console.log('000', state.knowledgePoint[payload.pointId][payload.difficulty][currentStage])
            const pageData = state.knowledgePoint[payload.pointId][payload.difficulty][currentStage];
            // console.log('pageData', pageData);
            const allPageData = state.knowledgePoint[payload.pointId][payload.difficulty];
            pageData.push(_.cloneDeep(question));
            if (pageData && pageData.length) {
                allPageData['new' + currentStage] = classifyArr(allPageData[currentStage], 'category');
            } else {
                allPageData['new' + currentStage] = [];
            }
            state.knowledgePoint[payload.pointId][payload.difficulty].hasAdd = true;
            state.pointEdited = true;
            // console.log('888', state.knowledgePoint[payload.pointId][payload.difficulty])
        },
        // 将所选问题从试题篮中移除 mutations
        [TypesPoints.POINTS_KB_OUT_BASKET](state, payload) {
            // console.log('移除', payload);
            // payload 参数 pointId (备课知识点ID) difficulty (备课知识点难度) questionId 问题ID
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions']; // 删除state knowledgePoint中的数据
            const STAGE_ENUM_BASKET = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.stage];
            let currentStageBasket = STAGE_ENUM_BASKET[payload.stage];
            let basketIdx = '';
            if (state.basket[payload.pointId]) {
                basketIdx = _.findIndex(state.basket[payload.pointId][currentStageBasket], { id: payload.questionId });
            } else {
                basketIdx = -1;
            }
            if (basketIdx > -1) {
                state.basket[payload.pointId][currentStageBasket].splice(basketIdx, 1);
            }
            // 移除各个难度下的相应 知识点
            let difficultyKeys = Object.keys(state.knowledgePoint[payload.pointId]);
            let difficultyKeysLen = difficultyKeys.length;
            if (difficultyKeysLen) {
                for (let i = 0; i < difficultyKeysLen; i++) {
                    let pointIdx = '';
                    state.knowledgePoint[payload.pointId][difficultyKeys[i]][currentStage].forEach(item => {
                        pointIdx = _.findIndex(item.value, questionItem => { return questionItem.id === payload.questionId; });
                        if (pointIdx > -1) {
                            item.value.splice(pointIdx, 1);
                        }
                    });
                    // let pointIdx = _.findIndex(state.knowledgePoint[payload.pointId][difficultyKeys[i]][currentStage], { id: payload.questionId });
                    // if (pointIdx > -1) {
                    //     state.knowledgePoint[payload.pointId][difficultyKeys[i]][currentStage].splice(pointIdx, 1);
                    // }
                }
            }
            state.pointEdited = true;
        },
        // 使用已有的讲义，替换当前知识点
        [TypesPoints.POINTS_REPLACE_POINT](state, payload) {
            // payload 参数 sessionNme (存在表示课节名称需同步修改), knowledgePoint 知识点对象
            // 注：有种情况较为危险 传入的knowledgePoint id 已存在 知识点列表中，先在替换前做判断阻止
            let currentPoint = _.cloneDeep(state.currentPoint);
            let point = payload.knowledgePoint; // 讲义的知识点
            point.difficulty = point.difficulty;
            let current = {
                id: point.id,
                name: point.name,
                difficulty: point.difficulty
            };
            let pointListIdx = _.findIndex(state.pointList, { id: currentPoint.id });
            if (pointListIdx > -1) {
                point.newpracticeLessonQuestions = classifyArr(point.practiceLessonQuestions, 'category');
                // point.newpreLessonQuestions = classifyArr(point.preLessonQuestions, 'category');
                point.newwithinLessonQuestions = classifyArr(point.withinLessonQuestions, 'category');
                let knowledgePoint = _.cloneDeep(state.knowledgePoint);
                delete knowledgePoint[current.id];
                knowledgePoint[current.id] = {};
                knowledgePoint[current.id][current.difficulty] = point;
                state.knowledgePoint = knowledgePoint;
                state.pointList.splice(pointListIdx, 1, current);
                state.currentPoint = current;
            }

            if (payload.sessionName) {
                state.sessionName = payload.sessionName;
            }
            state.pointEdited = true;
        }
    },
    actions: {
    // 编辑课节， 新增知识点需要获取推荐习题 actions
        [TypesPoints.POINTS_EDIT_SESSION](ctx, { name, pointList, newPoints, removePoints }) {
            let apiPromises = newPoints.map(item => {
                return Vue.http.get(`/v1/knowledge-base/knowledge-points/${item.id}/courseware`, {
                    params: {
                        difficulty: item.difficulty || 'normal'
                    }
                }).then(resp => {
                    return Vue.checkResp(resp, {});
                });
            });
            return Promise.all(apiPromises).then(coursewareList => {
                let list = pointList.map(item => {
                    item.difficulty = item.difficulty || 'normal';
                    return item;
                });
                let data = {
                    name,
                    pointList: list,
                    removePoints,
                    coursewareList
                };
                ctx.commit(TypesPoints.POINTS_SET_SESSION, data);
                return coursewareList;
            });
        },
        // 讲义难度更新，获取新的推荐习题
        [TypesPoints.POINTS_GET_DIFFICULTY_POINT](ctx, { knowledgePointId, difficulty }) {
            // return Vue.http.get(`/v1/knowledge-base/knowledge-points/${knowledgePointId}/courseware`, {
            return Vue.http.get(`/v1/knowledge-base/knowledge-points/${knowledgePointId}/courseware`, {
                params: {
                    difficulty
                }
            }).then(resp => {
                return Vue.checkResp(resp, {});
            }).then(data => {
                data.knowledgePointId = knowledgePointId;
                ctx.commit(TypesPoints.POINTS_SET_DIFFICULTY_POINT, data);
                return data;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_points.js